import styled from '@emotion/styled'

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const StyledImg = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`
